import configurations from './configurations';
import userSchemaMapper from './userSchemaMapper';

const modules = {
	configurations,
	userSchemaMapper,
};

export default modules;
